import { render, staticRenderFns } from "./PopupNewVersionWe.vue?vue&type=template&id=65bdc433&scoped=true"
import script from "./PopupNewVersionWe.vue?vue&type=script&lang=js"
export * from "./PopupNewVersionWe.vue?vue&type=script&lang=js"
import style0 from "./PopupNewVersionWe.vue?vue&type=style&index=0&id=65bdc433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bdc433",
  null
  
)

export default component.exports